import { createAtom } from '../../../1stlog-ui/src/utils/recoil'
import { TOrderEntryFormValues } from '../../../shipmetrics-shared/containers/OrderEntry/types'

const prefix = 'containers/Templates'

export const templateValuesState = createAtom<TOrderEntryFormValues | null>({
  prefix,
  key: 'templateValues',
  default: null,
})

export const templatesState = createAtom({
  prefix,
  key: 'templates',
})

export const isLoadingState = createAtom({
  prefix,
  key: 'isLoading',
})
